import { render } from "./PaneFeaturedResale.vue?vue&type=template&id=7231a688&scoped=true&ts=true"
import script from "./PaneFeaturedResale.vue?vue&type=script&lang=ts"
export * from "./PaneFeaturedResale.vue?vue&type=script&lang=ts"

import "./PaneFeaturedResale.vue?vue&type=style&index=0&id=7231a688&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7231a688"]])

export default __exports__